import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
  import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class LoadCsvService {

  private http = inject(HttpClient)
  private translate = inject(TranslateService)

  getDataFromCsvNew(path: string, separateOperator: string, zipOrLang: string) {
    // return this.http
  }
  // getDataFromCsv(path: string, separateOperator: string, array, zipOrLang: string) {
  //   let defLanguage = this.translate.getDefaultLang();
  //   this.http.get(path, { responseType: 'text' }).subscribe({
  //     next: (data) => {
  //       data.split(/\r?\n/).forEach(country => {
  //         let splitedData = country.split(separateOperator)
  //         if (zipOrLang === 'lang') {
  //           array.push(
  //             {
  //               Name: splitedData[0],
  //               Id: splitedData[1],
  //               IsEu: splitedData[2],
  //               Id3: splitedData[3]
  //             }
  //           )
  //         }
  //         if (zipOrLang === 'zipCode') {
  //           array.push(
  //             {
  //               zipCode: splitedData[0],
  //               City: splitedData[1],
  //               Country: splitedData[2]
  //             })
  //         }
  //       })
  //       return array
  //     },
  //     error: (err) => {
  //       console.error(err)
  //     }
  //   });
  // }


getDataFromCsv(
  path: string,
  separateOperator: string,
  zipOrLang: 'lang' | 'zipCode'
): Observable<any[]> {

  return this.http.get(path, { responseType: 'text' }).pipe(
    map((data: string) => {
      return data
        .split(/\r?\n/)
        .filter(line => line.trim().length > 0)
        .map(line => {
          const splitedData = line.split(separateOperator);

          if (zipOrLang === 'lang') {
            return {
              Name: splitedData[0],
              Id: splitedData[1],
              IsEu: splitedData[2],
              Id3: splitedData[3]
            };
          }

          if (zipOrLang === 'zipCode') {
            return {
              zipCode: splitedData[0],
              City: splitedData[1],
              Country: splitedData[2]
            };
          }

          return null;
        })
        .filter(item => item !== null);
    })
  );
}


}
